import React from 'react';

import Chip from '../Chip';
import Icon from 'components/Icon/Icon';
import IconColored from 'components/IconColored/IconColored';
import { LANG_LEVEL_TO_ICON_COLORED_NAME, LANG_LEVEL_TO_ICON_NAME, LanguageLevelInt } from 'constants/languageLevels';

interface Props {
    languageName: string;
    level: LanguageLevelInt;
    highlighted?: boolean;
}

const LanguageLevelChip: React.FC<Props> = ({ languageName, level, highlighted = false }) => {
    return (
        <Chip
            isCompact
            variant={highlighted ? 'selected' : 'default'}
            afterContent={
                highlighted ? (
                    <Icon name={LANG_LEVEL_TO_ICON_NAME[level]} width={20} color={level === 4 ? 'green' : 'orange'} />
                ) : (
                    <IconColored
                        name={LANG_LEVEL_TO_ICON_COLORED_NAME[level]}
                        width={20}
                        color={level === 4 ? 'green' : 'orange'}
                    />
                )
            }
        >
            {languageName}
        </Chip>
    );
};

export default React.memo(LanguageLevelChip);
